var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ValidatedForm,_vm._g({attrs:{"fm":_setup.formDef.form,"validation":_setup.formDef.validation},on:{"update:validation":function($event){return _vm.$set(_setup.formDef, "validation", $event)}}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }